import swal from 'sweetalert2';
import PropTypes from 'prop-types';

const showDialog = props => {
  const {
    title,
    text,
    link,
    type,
    html,
    showCancelButton,
    confirmButtonText,
    cancelButtonText
  } = props;
  const clickable = link && `<a href=${link} target="_blank" rel="noopener noreferrer">${link}</a>`;
  return swal({
    title: title,
    text: text,
    type: type,
    html: html || clickable,
    showCancelButton: showCancelButton || false,
    confirmButtonText: confirmButtonText || 'Ok',
    cancelButtonText: cancelButtonText || 'Cancel',
    confirmButtonClass: 'button--primary',
    cancelButtonClass: 'button--secondary',
    customClass: 'swal-global'
  });
};

showDialog.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
  html: PropTypes.object,
  showCancelButton: PropTypes.bool,
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  confirmButtonClass: PropTypes.string,
  cancelButtonClass: PropTypes.string,
  customClass: PropTypes.string
};
showDialog.defaultProps = {
  showCancelButton: false,
  confirmButtonText: 'Ok',
  cancelButtonText: 'Cancel'
};
export default showDialog;